import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';

type SettingsMap = Record<string, string>;

let cachedSettings: SettingsMap | null = null;
let fetchPromise: Promise<SettingsMap> | null = null;

const fetchSettings = async (): Promise<SettingsMap> => {
  if (cachedSettings) return cachedSettings;
  if (fetchPromise) return fetchPromise;

  fetchPromise = supabase
    .from('site_settings')
    .select('key, value')
    .then(({ data }) => {
      const map: SettingsMap = {};
      if (data) data.forEach((row) => { map[row.key] = row.value ?? ''; });
      cachedSettings = map;
      fetchPromise = null;
      return map;
    });

  return fetchPromise;
};

export const invalidateSiteSettings = () => {
  cachedSettings = null;
  fetchPromise = null;
};

export const useSiteSettings = () => {
  const [settings, setSettings] = useState<SettingsMap>(cachedSettings ?? {});
  const [loading, setLoading] = useState(!cachedSettings);

  useEffect(() => {
    if (cachedSettings) { setSettings(cachedSettings); setLoading(false); return; }
    setLoading(true);
    fetchSettings().then((s) => { setSettings(s); setLoading(false); });
  }, []);

  const get = (key: string, fallback = '') => settings[key] ?? fallback;

  return { settings, loading, get };
};
